// extracted by mini-css-extract-plugin
export var content = "styles-module--content--tmcqr";
export var copy = "styles-module--copy--QrB-X";
export var prepareForAppointment = "styles-module--prepareForAppointment--0fN83";